import type { paths } from '@pba/types-openapi-client';
import type { RouteParamsRequest } from '@pba/utils';
import { type ApiClientResponse, apiClient, routes } from 'common/services';

type GetCommentsResponse =
  paths['/v3/content_objects/{id}/comments']['get']['responses']['200']['content']['application/json'];
type GetCommentsRouteParams = paths['/v3/content_objects/{id}/comments']['get']['parameters']['path'];

export const getComments = async ({ routeParams: { id } }: RouteParamsRequest<GetCommentsRouteParams>) =>
  apiClient.get<GetCommentsResponse, ApiClientResponse<GetCommentsResponse>>(routes.contentObjects.comment.get(id));
